import { combineReducers } from "@reduxjs/toolkit";
import arNacidStatusesReducer from "./arNacidStatuses";
import arUniStatusesReducer from "./arUniStatuses";
import arRegProfStatusesReducer from "./arRegProfStatuses";
import eduLevelsReducer from "./eduLevels";
import countriesDataReducer from "./countriesData";
import loggedUser from "./loggedUser";
import nationalUniversities from "./nationalUniversities";
import arUniEntryRequestStatuses from "./arUniEntryRequestStatuses";
import arUniEntryRequestConstants from "./arUniEntryRequestConstants";
import servicesDescriptions from "./servicesDescriptions";
import profGroup from "./profGroup";

const appDataReducers = combineReducers({
  arNacidStatuses: arNacidStatusesReducer,
  arUniStatuses: arUniStatusesReducer,
  arRegProfStatuses: arRegProfStatusesReducer,
  eduLevels: eduLevelsReducer,
  countries: countriesDataReducer,
  loggedUser: loggedUser,
  nationalUniversities: nationalUniversities,
  arUniEntryRequestStatuses: arUniEntryRequestStatuses,
  arUniEntryRequestConstants: arUniEntryRequestConstants,
  servicesDescriptions: servicesDescriptions,
  profGroup: profGroup,
});

export default appDataReducers;
